import { render, staticRenderFns } from "./Proposals.vue?vue&type=template&id=742927aa&scoped=true"
import script from "./Proposals.vue?vue&type=script&lang=js"
export * from "./Proposals.vue?vue&type=script&lang=js"
import style0 from "./Proposals.vue?vue&type=style&index=0&id=742927aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742927aa",
  null
  
)

export default component.exports